$(document).ready(function() {
  var wWidth = $('html, body').width();

  $(".cel-mask").mask("(99) 9 9999-9999");
  $(".number-mask").mask("0999");
  $(".rg-mask").mask("99.999.999-9");
  $(".cnpj-mask").mask("99.999.999/9999-99");
  $(".cpf-mask").mask("999.999.999-99");
  $(".cep-mask").mask("99999-999");
  $(".note-mask").mask("9");

  var SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  },
  spOptions = {
    onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
      }
  };

  $('.phone-mask').mask(SPMaskBehavior, spOptions);
});
